import { Button, ButtonProps } from '@blueprintjs/core';

export function ClearFilterButton({
  title,
  disabled,
  ...props
}: {
  title: string;
  disabled: boolean;
} & Omit<ButtonProps, 'minimal' | 'intent' | 'icon' | 'text' | 'disabled'>) {
  return (
    <Button
      {...props}
      minimal
      intent="primary"
      icon="trash"
      text={`Clear ${title}`}
      disabled={disabled}
    />
  );
}
